<div class="layout-wrapper" [class.background-blur]="showGoogleAuth" [attr.inert]="showGoogleAuth ? '' : null">
    <div class="layout-wrapper-inner vh-100 overflow-hidden">
        <div class="layout-header px-3 py-2 d-flex justify-content-between align-items-center">
            <div class="banner d-flex align-items-center mxw-500 w-100 justify-content-between">
                <img src="assets/images/icons/hamburger-menu.svg" alt="" class="d-xxl-none me-4"
                    (click)="openNavMenu()" style=" filter: brightness(10.5);">
                <img src="assets/images/icons/recuveryfavicon.svg" alt="" class="me-4" (click)="openNavMenu()">
                
                <div class="btn-group me-4" dropdown>
                    <div id="button-basic" dropdownToggle style="cursor: pointer;" class="d-flex flex-column align-item-center justify-content-center">
                        <p class="text-white fs-16 fw-600 m-0">
                        Timezone <span class="p-1 pt-0 radius-4 bg-danger fs-12 ms-1">{{selectedTimezone && selectedTimezone['offset']}}</span> 
                      </p>
                      <p class="text-white fs-13 fw-600 m-0">
                        <span class="p-0 fs-12">{{currentTime ? (currentTime | date : "MMM dd, yyyy, hh:mm:ss a" : selectedTimezone?.val) : ''}}</span> 
                      </p>
                    </div>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu" role="menu" aria-labelledby="button-basic">
                        <li class="px-1" *ngFor="let timezone of timezoneList" role="menuitem" class="cursor">
                            <a (click)="changeTimezone(timezone)" class="dropdown-item">{{timezone.offset}}-{{timezone.name}}<br /><span class="fs-14">{{currentTime | date : "MMM dd, yyyy, hh:mm:ss a" : timezone.val.toString()}}</span></a>
                        </li>
                    </ul>
                </div>

                <div class="btn-group" dropdown>
                    <p id="button-basic" dropdownToggle class="text-white fs-16 fw-600 m-0" style="cursor: pointer;">
                        Country <span class="p-1 pt-0 radius-4 bg-danger fs-12 ms-1">{{selectedCountry && selectedCountry['country_name'] || 'United States'}}</span>
                      </p>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu pointer" role="menu" aria-labelledby="button-basic">
                        <li *ngFor="let country of countryList" role="menuitem">
                            <a (click)="changeCountry(country)" class="dropdown-item">{{country.country_name}}</a>
                        </li>
                    </ul>
                </div>
            </div>
            <div class="d-flex">
                <!-- <div class="d-flex align-items-center me-3">
                    <label class="text-white fs-14 fw-600 mb-2">Chat</label>
                    <div class="mx-2">
                        <label class="switch switch-md switch-success ">
                            <input type="checkbox" [checked]="profileData.active_for_chat" (change)="toggleChangeChat()" />
                            <span></span>
                        </label>
                    </div>
                </div> -->
                <!-- <div class="d-flex align-items-center me-2">
                    <a href="#" target="_blank" rel="noopener noreferrer" class="wallboard-btn">
                        <span>Wallboard</span>
                        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M7 17L17 7"/><path d="M8 7h9v9"/></svg>
                    </a>
                </div> -->
                <div class="position-relative me-2 mt-1" >
                     <button *ngIf="logs_data.length" class="mx-2 mt-2 rounded-pill btn btn-secondary py-1" (click)="toggleDrawer()" >Communication Center</button>
                     <span *ngIf="hasNewActivity==true" class="new-badge-gradient mega">NEW</span>
                </div>
                <div class="d-flex align-items-center me-0">
                    <div class="position-relative me-2">
                        <img src="assets/images/icons/bell-icon.png" width="30" class="mx-2" (click)="toggleDrawerNotifications()"
                            style="background-color: #FFFFFF; border-radius: 20px!important; cursor: pointer;" />
                        <span
                            class="position-absolute bg-danger text-white rounded-circle fs-12 d-flex align-items-center justify-content-center text-center custom_css"
                            [ngClass]="{ 'hw-24' :  notification_count && notification_count > 99}" *ngIf="notification_count > 0">
                            {{notification_count && notification_count > 99 ? '99+' : notification_count}}
                        </span>
                    </div>
                    <label class="text-white fs-14 fw-600 mb-2">Live</label>
                    <div class="mx-2">
                        <label class="switch switch-md switch-success ">
                            <input type="checkbox" [checked]="isDummy" (change)="toggleChange()" />
                            <span [ngClass]="!isDummy ? 'lightgreenBG' : 'bg-lightgrey' "></span>
                        </label>
                    </div>
                    <label class="text-white fs-14 fw-600 mb-2">Dummy</label>
                </div>
                <div class="nav-item d-flex align-items-center">
                    <a class="nav-link" (click)="searchNavBarShow = !searchNavBarShow" style="padding: 5px 20px;">
                        <img src="assets/images/png/search.png" />
                    </a>
                </div>
                <div class="btn-group" dropdown >
                    <button id="button-basic" dropdownToggle placement="bottom center" type="button"
                        class="btn -dropdown-toggle" aria-controls="dropdown-basic">
                        <img src="assets/images/icons/profile_placeholder.png" class="profile-icon rounded-circle border hw-40"
                        alt="" ><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="fill: white;"
                        class="toggle-arrow hw-20 ms-3" >
                        <path
                            d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" />
                    </svg> <span class="caret"></span>
                    </button>
                    <ul id="dropdown-basic" *dropdownMenu class="dropdown-menu dropdown-menu-right width" role="menu"
                        aria-labelledby="button-basic">
                        <div class="pb-3 border-bottom">
                            <p class="text-center m-0 fs-14 fw-500 text-capitalize">{{admin_profile.admin_name}}</p>
                        <p class="text-center m-0 fs-14 fw-500 text-capitalize">Role: {{role}}</p>
                        </div>
                        <li role="menuitem" class="border-bottom py-1">
                            <button class="dropdown-item py-1 fs-14 fw-500" [routerLink]="['/app/home/profile']" tappable><img src="assets/images/png/user.png" class="me-2 hw-18"
                                alt="" > Profile</button>
                        </li>
                        <li role="menuitem" class=" d-flex align-items-center py-1">
                            <button class="dropdown-item py-1 fs-14 fw-500" (click)="showLogoutModal()" tappable><img src="assets/images/png/log-out.png" class="me-2 hw-18"
                                alt="" > Logout</button>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <div class="layout-body d-flex">
            <div class="side-menu-wrapper h-100 w-100 overflow-auto hide-scroll-bar border bg-white top-0 start-0"
                id="mySidenav">
                <img src="assets/images/icons/cross-icon.svg" alt=""
                    class="close-menu text-white d-xxl-none position-absolute top-0 end-0 mt-3 me-3 hw-24"
                    (click)="closeNavMenu()">
                <ul class="menu p-0 pt-3">
                    <li *ngFor="let menu of menuList" class="decoration-none px-3 pb-3 cursor">
                        <span class="d-flex w-100 justify-content-between" (click)="toggleMenu(menu)">
                            <div class="d-flex align-items-center">
                                <img [src]="'assets/images/sidebarIcons/' + menu.icon + '.png'"  alt="" style="height: 20px;margin-right: 6px;"  [ngClass]="menu.isOpen ? 'green-icon' : '' "  *ngIf="menu.icon">
                                <p class="m-0 fs-14" [ngClass]="{ 'text-success fw-600': menu.isOpen }">
                                    {{ menu.menu_name }}
                                </p>
                            </div>
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512" style="height: 16px;"
                                class="toggle-arrow" *ngIf="menu.submenu" [ngClass]="{ 'rotate': menu.isOpen }">
                                <path
                                    d="M201.4 374.6c12.5 12.5 32.8 12.5 45.3 0l160-160c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L224 306.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l160 160z" />
                            </svg>
                        </span>
                        <ul class="sub-menu pl-1 overflow-hidden position-relative"
                            [ngClass]="{ 'active': menu.isOpen }">
                            <li *ngFor="let subMenu of menu.submenu" class="decoration-none p-1 fs-14" [ngClass]=" selectedSubMenu && selectedSubMenu.isOpen && subMenu.path == selectedSubMenu.path ? 'text-success fw-600' : 'text-muted'"
                                (click)="toggleMenu(subMenu,menu)">
                                {{ subMenu.menu_name }}
                            </li>
                        </ul>
                    </li>
                    </ul>
                    
                    </div>
                    <div class="right-content overflow-auto flex-fill">
                        <div *ngIf="(role_id != 1) && (role_id != 4) && (role_id != 13)" class="position-relative">
                            <div class="calling" *ngIf="call || alert || (dialer.showIcomming && !dialer.renderInline) || dialer.openSummaryModal">
                            <app-calling *ngIf="call" [type]="call ? 'call' : 'alert'"></app-calling>
                            <!-- A host that draws the call itself (the contract communication
                                 drawer) sets renderInline; this overlay stays out of its way.
                                 The call summary is a different matter: it belongs to app-dial
                                 but is only asked for once the line is down, at which point
                                 showIcomming is already false and renderInline has been
                                 released — so it needs a mount condition of its own, or a call
                                 drawn inline leaves the summary with nowhere to render. -->
                            <app-dial *ngIf="(dialer.showIcomming && !dialer.renderInline) || dialer.openSummaryModal" [dial]="dialer.showIcomming"></app-dial>
                        </div>
                        </div> 
                        <router-outlet></router-outlet>
                    </div>
                    
                    <!-- <div class="global-chat" *ngIf="this._main.global_bar">
                <app-support-chat [global_bar]="true"></app-support-chat>
            </div> -->
        </div>
    </div>
</div>
<div *ngIf="emailViewerOpen" class="sms-viewer-backdrop" (click)="closeEmailViewer()"
    (document:keydown.escape)="closeEmailViewer()">
    <div *ngIf="selectedEmailPreview as activeEmail" class="email-viewer-modal" (click)="$event.stopPropagation()">
        <div class="sms-viewer-header">
            <div class="sms-viewer-title-group">
                <div class="sms-viewer-icon-shell email-viewer-icon-shell">
                    <img src="assets/images/icons/Vector.png" alt="Email">
                </div>
                <div class="sms-viewer-heading-content">
                    <p class="sms-viewer-eyebrow">Email preview</p>
                    <h3 class="sms-viewer-title email-viewer-title">
                        {{ activeEmail.subject || 'No subject available' }}
                    </h3>
                    <div class="sms-viewer-meta">
                        <span class="sms-viewer-pill email-viewer-pill">
                            From {{ activeEmail.from_email_id }}
                        </span>
                        <span *ngIf="activeEmail.attachments?.length" class="sms-viewer-pill">
                            {{ activeEmail.attachments.length }}
                            {{ activeEmail.attachments.length === 1 ? 'attachment' : 'attachments' }}
                        </span>
                    </div>
                </div>
            </div>

            <button type="button" class="sms-viewer-close" (click)="closeEmailViewer()">
                <img src="assets/images/icons/cross-icon.svg" alt="Close">
            </button>
        </div>

        <div class="email-viewer-body hide-scroll-bar">
            <div class="email-viewer-summary">
                <div class="email-viewer-summary-item">
                    <span class="email-viewer-summary-label">From</span>
                    <strong class="email-viewer-summary-value">{{ activeEmail.from_email_id }}</strong>
                </div>
                <div class="email-viewer-summary-item email-viewer-summary-item--right">
                    <span class="email-viewer-summary-label">Received</span>
                    <strong class="email-viewer-summary-value">
                        {{ activeEmail.created | date:'MMM dd, yyyy, hh:mm a':_shared.timezone }}
                    </strong>
                </div>
            </div>

            <div class="email-viewer-content-panel">
                <div class="email-content-render" [innerHTML]="selectedEmailPreviewHtml" appSafeExternalLinks></div>
            </div>

            <div *ngIf="activeEmail.attachments?.length" class="email-viewer-attachments">
                <a *ngFor="let attachment of activeEmail.attachments" [href]="attachment.url" target="_blank"
                    rel="noopener noreferrer" class="email-viewer-attachment" (click)="$event.stopPropagation()">
                    <img [src]="getFileIcon(attachment.url)" alt="Attachment">
                    <span>{{ attachment.name }}</span>
                </a>
            </div>
        </div>
    </div>
</div>
<div *ngIf="isCollapsed || isCollapsedNotifications">
    <app-navsearch [visible]="searchNavBarShow" (onclose)="searchNavBarShow = false"></app-navsearch>
</div>
<div class="drawer-container" *ngIf="!isCollapsedNotifications">
    <div class="drawer-overlay" *ngIf="!isCollapsedNotifications" (click)="toggleDrawerNotifications()"></div>

    <div class="drawer-content" [@drawerState]="isCollapsedNotifications ? 'closed' : 'open'">
        <!-- <button class="close-btn" (click)="toggleDrawer()">✖</button> -->
        <img src="assets/images/icons/cross-icon.svg" class="close-btn hw-30 p-1 border rounded-circle cursor" alt=""
            (click)="toggleDrawerNotifications()">
        <p>Notifications</p>

        <div class="list-group mt-3 notification-list">
            <div *ngFor="let notification of notifications;let i=index"
                class="list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                [ngClass]="{'bg-primary':(!notification.read_at || notification.read_at==null)}"
                style="cursor: pointer!important;">
                <div class="d-flex flex-column"
                    [ngClass]="{'text-white':(!notification.read_at || notification.read_at==null)}"
                    (click)="redirectToNotification(notification, i)">
                    <strong>{{ notification.title }} || {{ notification.admin_name }}</strong>
                    <p class="mb-0 small">{{ notification.message }}</p>
                    <p class="mb-0 small">
                        {{notification.sent_at | date:'MM/dd/yyyy hh:mm a':_shared.timezone}}
                        ({{notificationTimezoneName ? notificationTimezoneName: 'X'}})
                    </p>
                </div>
            </div>

            <div *ngIf="notifications.length === 0" class="text-center text-muted mt-3">
                <p>No new notifications</p>
            </div>

            <div class="d-flex justify-content-between mt-3 p-2">
                <button class="btn btn-primary btn-sm" style="margin-top: 0px;font-size: 12px;padding: 7px 0px;"
                    (click)="viewMore()">View All</button>
                <a class="mark-all-read" style="margin-top: 5px; cursor:pointer" (click)="markAllAsRead()">Mark All as
                    Read</a>
            </div>
        </div>
    </div>
</div>
<ng-container >
    <ng-template #loginAuthentication>
    <div class="modal-content border-0">
    <div class="position-relative bg-white radius-16">
      <div class="modal-header border-0 p-3 m-0 text-center fs-20 fw-700 justify-content-center">
        Access Restricted – Confidential System
      </div>
  
      <div class="modal-body p-4 border-top border-bottom">
        <p class="fs-14 fw-500 grey-106 mb-1">
          You are entering <strong>Debt Recuvery Admin Panel.</strong>
        </p>
        <p class="fs-14 fw-500 grey-106 mb-4">
          All actions within this system are monitored and logged in real-time.
        </p>
        <h4 class="fs-16 fw-700 mb-3">
          By proceeding, you agree to:
        </h4>
        <ul>
          <li class="fs-14 fw-500 grey-106 mb-1">
            Abide by all data privacy and confidentiality policies
          </li>
          <li class="fs-14 fw-500 grey-106 mb-1">
            Handle all information in accordance with company security standards
          </li>
          <li class="fs-14 fw-500 grey-106 mb-1">
            Not misuse, share, or disclose any sensitive data
          </li>
        </ul>
        <button class="btn btn-primary cursor mt-3" (click)="proceedToLogin()">I Acknowledge</button>
      </div>
      <div class="modal-footer">
       <div class="d-flex align-items-start">
        <img src="assets/images/icons/danger.svg" class="me-2 hw-16 mt-1" alt="">
        <p class="fs-12 fw-600 text-danger">
          Any unauthorized access, misuse, or breach of confidentiality will be treated as a serious violation of company policy and may result in disciplinary action, termination, or legal consequences.
        </p>
       </div>
      </div>
    </div>
  </div>
  </ng-template>
</ng-container>

<div *ngIf="smsViewerOpen" class="sms-viewer-backdrop" (click)="closeSmsViewer()"
    (document:keydown.escape)="closeSmsViewer()">
    <div *ngIf="selectedSmsThread as activeSms" class="sms-viewer-modal" (click)="$event.stopPropagation()">
        <div class="sms-viewer-header">
            <div class="sms-viewer-title-group">
                <div class="sms-viewer-icon-shell">
                    <img src="assets/images/icons/Vector_sms.png" alt="SMS">
                </div>
                <div class="sms-viewer-heading-content">
                    <p class="sms-viewer-eyebrow">SMS conversation</p>
                    <h3 class="sms-viewer-title">{{ activeSms.from_number | maskSensitive }}</h3>
                    <div class="sms-viewer-meta">
                        <span class="sms-viewer-pill">
                            {{ activeSms.messages?.length || 0 }}
                            {{ (activeSms.messages?.length || 0) === 1 ? 'message' : 'messages' }}
                        </span>
                        <span class="sms-viewer-pill">
                            Latest {{ timeAgo(activeSms.created) }}
                        </span>
                    </div>
                </div>
            </div>

            <button type="button" class="sms-viewer-close" (click)="closeSmsViewer()">
                <img src="assets/images/icons/cross-icon.svg" alt="Close">
            </button>
        </div>

        <div class="sms-viewer-body hide-scroll-bar">
            <div *ngIf="activeSms.messages?.length; else smsViewerEmpty">
                <div *ngFor="let msg of activeSms.messages" class="sms-message-card">
                    <div class="sms-message-meta">
                        <span class="sms-message-badge">Inbound SMS</span>
                        <span>{{ msg.created | date:'MMM dd, yyyy, hh:mm a':_shared.timezone }}</span>
                    </div>
                    <p class="sms-message-text">{{ msg.content || 'No message content available.' }}</p>
                </div>
            </div>

            <ng-template #smsViewerEmpty>
                <div class="sms-viewer-empty">
                    No messages available for this number yet.
                </div>
            </ng-template>
        </div>
    </div>
</div>
<div *ngIf="isCollapsed">
    <app-navsearch [visible]="searchNavBarShow" (onclose)="searchNavBarShow = false"></app-navsearch>
</div>
<div class="drawer-container" *ngIf="!isCollapsed">
    <div class="drawer-overlay" *ngIf="!isCollapsed" (click)="toggleDrawer()"></div>

    <div class="drawer-content" [ngClass]="isCollapsed ? 'closed' : 'open'">
        <img src="assets/images/icons/cross-icon.svg" class="close-btn hw-30 p-1 border rounded-circle cursor" alt=""
            (click)="toggleDrawer()" />

        <p>Communication Center</p>

        <div class="list-group mt-3 notification-list">
        <div class="tabsContainer">
        <p class="fw-600 conditional_border tab-item"
            [ngClass]="{
            active: selectedTab === tabs.unmapped,
            'text-flash': hasNewUnmapped
            }"
            (click)="openUnmapped()">
            <span class="tab-label">
            Unmapped
            <span *ngIf="newUnmappedCount > 0" class="tab-count-unmapped">
            {{ newUnmappedCount }}
            </span>
            </span>
        </p>

        <p class="fw-600 conditional_border tab-item"
            [ngClass]="{
            active: selectedTab === tabs.mapped,
            'text-flash': hasNewMapped
            }"
            (click)="openMapped()">
            <span class="tab-label">
            Mapped
            <span *ngIf="newMappedCount > 0" class="tab-count-mapped active">
            {{ newMappedCount }}
            </span>

            </span>
        </p>
        </div>

            <ng-container *ngIf="selectedTab === tabs.unmapped">
                <div class="subtabs-container">
                    <div class="subtabs-header">
                        <ul class="subtabs-list">
                            <li class="subtab" [ngClass]="{ active: selectedSubTab === Subtabs.Emails }"
                                (click)="selectSubTab(Subtabs.Emails)">
                                <span class="d-flex align-items-center gap-2">
                                    Emails
                                    <span *ngIf="newUnmappedEmailsCount > 0" class="badge bg-danger">{{ newUnmappedEmailsCount }}</span>
                                </span>
                            </li>

                            <li class="subtab" [ngClass]="{ active: selectedSubTab === Subtabs.Messages }"
                                (click)="selectSubTab(Subtabs.Messages)">
                                <span class="d-flex align-items-center gap-2">
                                    Messages
                                    <span *ngIf="newUnmappedMessagesCount > 0" class="badge bg-danger">{{ newUnmappedMessagesCount }}</span>
                                </span>
                            </li>
                            <li class="subtab" [ngClass]="{ active: selectedSubTab === Subtabs.calls }"
                                (click)="selectSubTab(Subtabs.calls)">
                                <span class="d-flex align-items-center gap-2">
                                    Calls
                                    <span *ngIf="newUnmappedCallsCount > 0" class="badge bg-danger">{{ newUnmappedCallsCount }}</span>
                                </span>
                            </li>
                        </ul>

                        <div class="comm-search">
                            <i class="fa fa-search comm-search-icon"></i>
                            <input type="text" class="comm-search-input" [(ngModel)]="communicationSearch"
                                [placeholder]="searchPlaceholder" />
                            <i class="fa fa-times comm-search-clear" *ngIf="communicationSearch"
                                (click)="clearCommunicationSearch()"></i>
                        </div>
                    </div>
                    <div class="tab-content" [ngSwitch]="selectedSubTab">
                        <div *ngSwitchCase="Subtabs.Emails">
                            <div class="py-2">
                                <p class="m-0">{{calculatedate(getFilteredUnmappedEmails())}}</p>
                            </div>
                            <div *ngFor="let data of getFilteredUnmappedEmails()"
                                class="email-card list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                                style="padding: 15px;"
                                 [ngClass]="{ 'flash-new': data.isNew }"
                                >
                                <div class="d-flex gap-2" style="align-items: center; ">
                                    <img src="assets/images/icons/Vector.png" style="height: 15px;">
                                    From : <span 
                                            style="
                                                text-decoration: underline; 
                                                color:#2968DD; 
                                                max-width: 320px;
                                                overflow-wrap: anywhere;
                                                display: block;
                                            ">
                                            {{ data?.from_email }}
                                            </span>
                                </div>
            
                                <div class="d-flex gap-3" style="align-items: center;">
                                    <span style="opacity: 60%; font-size: 15px;">{{ timeAgo(data.created) }}</span>
                                    <i class="fa fa-eye" style="cursor:pointer" (click)="openEmailView(data, $event)">
                                    </i>
                                </div>
                            </div>
                            <div *ngIf="getFilteredUnmappedEmails().length === 0" class="text-center text-muted mt-3">
                                <p>{{ communicationSearch ? 'No Emails Found' : 'No Unmapped Email Logs' }}</p>
                            </div>
                        </div>
                        <div *ngSwitchCase="Subtabs.Messages">
                            <div class="py-2">
                                <p class="m-0">{{calculatedate(getFilteredUnmappedMessages())}}</p>
                            </div>
                            <div *ngFor="let sms of getFilteredUnmappedMessages()"
                                class="sms-row list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                                style="padding: 16px 18px; border-radius: 12px; border: 1px solid #E5E7EB; margin-bottom: 12px;"
                                 [ngClass]="{ 'flash-new': sms.isNew }"
                                >
                                <!-- LEFT SIDE -->
                                <div class="d-flex align-items-center gap-2">
                                    <img src="assets/images/icons/Vector_sms.png" style="height: 18px; opacity: 0.7;">
            
                                    <span style="font-size: 15px;">
                                        From:
                                        <span style="color:#2968DD;">
                                            {{ sms.from_number | maskSensitive}}
                                        </span>
                                    </span>
            
                                    <!-- Message Count -->
                                    <span *ngIf="sms.messages.length > 1" style="font-size: 13px; margin-left: 4px; color:#2e9b1c; font-weight: 600;">
                                        +{{ sms.messages.length }} messages
                                    </span>
                                </div>
            
                                <!-- RIGHT SIDE -->
                                <div class="d-flex align-items-center gap-3">
                                    <span style="opacity: 60%; font-size: 14px;">
                                        {{ timeAgo(sms.created) }}
                                    </span>
            
                                    <i class="fa fa-eye" style="cursor:pointer; opacity: 0.7; font-size: 16px;"
                                        (click)="openSmsView(sms, $event)">
                                    </i>
                                </div>
                            </div>

                            <div *ngIf="getFilteredUnmappedMessages().length === 0" class="text-center text-muted mt-3">
                                <p>{{ communicationSearch ? 'No Messages Found' : 'No Unmapped Message Logs' }}</p>
                            </div>
                        </div>
                        <div *ngSwitchCase="Subtabs.calls">
                                <div class="d-flex justify-content-between py-2 align-items-center">
                                    <p class="m-0">{{calculatedate(getFilteredUnmappedCalls())}}</p>
                                    <div class="btn-group" dropdown>
                                        <button id="button-calls-filter-unmapped" dropdownToggle type="button" 
                                            class="missed-calls-dropdown-btn d-flex align-items-center"
                                            [ngClass]="{ 'missed-calls-active': showMissedCalls }">
                                            <span class="dot me-2" *ngIf="!showMissedCalls && unmappedCallAlertCount > 0"></span>
                                            <span [ngClass]="showMissedCalls ? 'text-danger' : 'text-success'">
                                                {{ showMissedCalls ? 'Missed Calls' : 'All Calls' }}
                                            </span>
                                            <i class="fa fa-chevron-down ms-2 fs-10" style="opacity: 0.7;"></i>
                                        </button>
                                        <ul id="dropdown-calls-filter-unmapped" *dropdownMenu class="dropdown-menu dropdown-menu-right shadow-sm border-0 radius-12 py-2" role="menu">
                                            <li role="menuitem">
                                                <a class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 cursor" (click)="setMissedCallsFilter(false)">
                                                    <span class="fs-14 fw-600 text-success">All Calls</span>
                                                </a>
                                            </li>
                                            <li role="menuitem">
                                                <a class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 cursor" (click)="setMissedCallsFilter(true)">
                                                    <span class="fs-14 fw-600 text-danger">Missed Calls</span>
                                                    <span class="badge bg-danger rounded-pill ms-2 d-flex align-items-center justify-content-center" 
                                                          style="min-width: 20px; height: 20px; font-size: 11px;"
                                                          *ngIf="unmappedCallAlertCount > 0">
                                                        {{ unmappedCallAlertCount }}
                                                    </span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div *ngFor="let call of getFilteredUnmappedCalls()" class="sms-row list-group-item list-group-item-action d-flex justify-content-between align-items-center"
                                    style="padding: 16px 18px; border-radius: 12px; border: 1px solid #E5E7EB; margin-bottom: 12px;"
                                    [ngClass]="{ 'flash-new': call.isNew }">
                                    <div>
                                        <div class="d-flex justify-content-between align-items-center">
                                            <div class="d-flex gap-2 align-items-center">
                                                <img src="assets/images/icons/Vector_sms.png" style="height: 18px; opacity: 0.7;">
                                    
                                                <span style="font-size: 15px;">
                                                    From:
                                                    <span style="color:#2968DD;">
                                                        {{ call.from_number | maskSensitive }}
                                                    </span>
                                                </span>
                                            </div>
                                        </div>
                                        <div class="d-flex align-items-center gap-3 mt-2">
                                            <span style="opacity: 60%; font-size: 14px;">
                                                {{ timeAgo(call.created) }}
                                            </span>
                                        </div>
                                    </div>
                                    <div  style="cursor: pointer;">
                                        <div class="mt-1" style="font-size: 13px; opacity: 80%;">
                                        To :
                                        <span>{{ call.to_number | maskSensitive }}</span>
                                        </div>
                                        <div class="mt-1" style="font-size: 12px;">
                                            Status :
                                            <span [ngClass]="{
                                                'text-danger': call.call_status === 'no-answer',
                                                'text-success': call.call_status === 'completed'
                                            }">
                                                {{ call.call_status }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                                <div *ngIf="getFilteredUnmappedCalls().length === 0" class="text-center text-muted mt-3">
                                    <p *ngIf="communicationSearch">No Calls Found</p>
                                    <p *ngIf="!communicationSearch">{{ showMissedCalls ? 'No Missed Call Logs' : 'No Unmapped Call Logs' }}</p>
                                </div>
                        </div>
            
                    </div>
                </div>
            </ng-container>
            <ng-container *ngIf="selectedTab === tabs.mapped">
                <div class="subtabs-container">
                    <div class="subtabs-header">
                        <ul class="subtabs-list">
                            <li class="subtab" [ngClass]="{ active: selectedSubTab === Subtabs.Emails }"
                                (click)="selectSubTab(Subtabs.Emails)">
                                <span class="d-flex align-items-center gap-2">
                                    Emails
                                    <span *ngIf="newMappedEmailsCount > 0" class="badge bg-danger">{{ newMappedEmailsCount }}</span>
                                </span>
                            </li>

                            <li class="subtab" [ngClass]="{ active: selectedSubTab === Subtabs.Messages }"
                                (click)="selectSubTab(Subtabs.Messages)">
                                <span class="d-flex align-items-center gap-2">
                                    Messages
                                    <span *ngIf="newMappedMessagesCount > 0" class="badge bg-danger">{{ newMappedMessagesCount }}</span>
                                </span>
                            </li>
                            <li class="subtab" [ngClass]="{ active: selectedSubTab === Subtabs.calls }"
                                (click)="selectSubTab(Subtabs.calls)">
                                <span class="d-flex align-items-center gap-2">
                                    Calls
                                    <span *ngIf="newMappedCallsCount > 0" class="badge bg-danger">{{ newMappedCallsCount }}</span>
                                </span>
                            </li>
                        </ul>

                        <div class="comm-search">
                            <i class="fa fa-search comm-search-icon"></i>
                            <input type="text" class="comm-search-input" [(ngModel)]="communicationSearch"
                                [placeholder]="searchPlaceholder" />
                            <i class="fa fa-times comm-search-clear" *ngIf="communicationSearch"
                                (click)="clearCommunicationSearch()"></i>
                        </div>
                    </div>
                    <div class="tab-content" [ngSwitch]="selectedSubTab">
                        <div *ngSwitchCase="Subtabs.Emails">
                            <div class="py-2">
                                <p class="m-0">{{calculatedate(getFilteredMappedEmails())}}</p>
                            </div>
                            <div *ngFor="let group of getFilteredMappedEmails()"
                                class="email-card list-group-item list-group-item-action d-flex flex-column"
                                style="margin-right: 30px;"
                                [ngClass]="{ 'flash-new': group.isNew }"
                                >
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex gap-2" style="align-items: center; ">
                                        <img src="assets/images/icons/Vector.png" style="height: 15px;">
                                        From : <span style="text-decoration: underline;color:#2968DD;">
                                            {{group.from_email}}</span>
                                    </div>
                                    <div>
                                        <span style="opacity: 60%; font-size: 15px;">{{ timeAgo(group.created) }}</span>
                                    </div>
                                </div>
                                <div class="mt-2">
                                <span style="font-size: 12px; margin-right:10px;">
                                    Accounts ({{ group.accounts.length }}):
                                </span>

                                <ng-container
                                    *ngFor="
                                    let acc of group.accounts
                                    | slice:0:(group.showAllAccounts ? group.accounts.length : 3)
                                    "
                                >
                                    <span
                                    style="text-decoration: underline; cursor: pointer; color: #2968DD;
                                            background-color: #2968dd2f; border-radius: 10px;
                                            padding: 1px 6px; font-size: 13px;"
                                    (click)="Redirect(acc.splitReqId, 'emails'); markGroupAsRead(group)">
                                    {{ acc.accountId }}
                                    </span>
                                </ng-container>

                                <!-- + More -->
                                <button
                                    *ngIf="group.accounts.length > 3 && !group.showAllAccounts"
                                    class="btn btn-light btn-sm px-2 py-0"
                                    style="font-size: 13px; border-radius: 10px; opacity: 90%; margin-left: 6px;"
                                    (click)="group.showAllAccounts = true">
                                    +{{ group.accounts.length - 3 }} more
                                </button>

                                <!-- Show less -->
                                <button
                                    *ngIf="group.showAllAccounts"
                                    class="btn btn-link btn-sm ms-2"
                                    style="text-decoration: none; border: 1px solid rgba(0,0,0,0.11);
                                        color: black; border-radius: 10px; padding: 0 6px; font-size: 13px;"
                                    (click)="group.showAllAccounts = false">
                                    Show less
                                </button>
                                </div>


                            </div>
            
                            <div *ngIf="getFilteredMappedEmails().length === 0"
                                class="text-center text-muted mt-3">
                                <p>{{ communicationSearch ? 'No Emails Found' : 'No mapped Email Logs' }}</p>
                            </div>
                        </div>

                        <div *ngSwitchCase="Subtabs.Messages">
                            <div class="py-2">
                                <p class="m-0">{{calculatedate(getFilteredMappedMessages())}}</p>
                            </div>
                            <div *ngFor="let group of getFilteredMappedMessages()"
                                class="email-card list-group-item list-group-item-action d-flex flex-column"
                                style="margin-right: 30px;"
                                [ngClass]="{ 'flash-new': group.isNew }">
                                <div class="d-flex justify-content-between">
                                    <div class="d-flex gap-2" style="align-items: center; ">
                                        <img src="assets/images/icons/Vector_sms.png" style="height: 15px;">
                                        From : <span style="text-decoration: underline; color:#2968DD;">
                                            {{group.from_number | maskSensitive}}</span>
                                    </div>
                                    <div>
                                        <span style="opacity: 60%; font-size: 15px;">{{ timeAgo(group.created) }}</span>
                                    </div>
                                </div>
                                <div class="mt-2">
                                    <span style="font-size: 12px; margin-right:10px;">Accounts ({{ group.accountIds.length }}):</span>
            
                                    <!-- Show first 3 accounts -->
                                    <ng-container *ngIf="!group.showAllAccounts">
                                        <ng-container *ngFor="let acc of group.accountIds | slice:0:3; let i = index">
                                            <span
                                                style="text-decoration: underline; cursor: pointer; color: #2968DD;
                                                                background-color: #2968dd2f; border-radius: 10px; padding: 1px 6px; font-size: 13px;"
                                                (click)="Redirect(group.split_req_ids[i], 'messages'); markSmsGroupAsRead(group)">
                                                {{ acc }}
                                            </span>
                                            <span *ngIf="i < 2 && i < group.accountIds.length - 1">, </span>
                                        </ng-container>
            
                                        <!-- + More button -->
                                        <button *ngIf="group.accountIds.length > 3" class="btn btn-light btn-sm px-2 py-0"
                                            style="font-size: 12px; border-radius: 12px; border-radius: 10px; padding: 1px 6px; font-size: 13px; opacity: 90%; margin-top: 20px;"
                                            (click)="group.showAllAccounts = true;">
                                            +{{ group.accountIds.length - 3 }} more
                                        </button>
                                    </ng-container>
            
                                    <!-- Expanded list -->
                                    <ng-container *ngIf="group.showAllAccounts">
                                        <div class="mt-2">
                                            <ng-container *ngFor="let acc of group.accountIds; let j = index">
                                                <span
                                                    class="account-chip"
                                                    style="text-decoration: underline; cursor: pointer; color: #2968DD;
                                                                    background-color: #2968dd2f; border-radius: 10px; padding: 1px 6px; font-size: 13px; width: fit-content;"
                                                    (click)="Redirect(group.split_req_ids[j], 'messages'); markSmsGroupAsRead(group)">
                                                    {{ acc }}
                                                </span>
                                                <span *ngIf="j < group.accountIds.length - 1">, </span>
                                            </ng-container>
            
                                            <!-- Show Less -->
                                            <button class="btn btn-link btn-sm ms-2" (click)="group.showAllAccounts = false"
                                                style="text-decoration: none; border: 1px solid rgba(0, 0, 0, 0.11); color: black; border-radius: 10px; padding: 0px; opacity: 90%;font-size: 13px;">
                                                Show less 
                                            </button>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
            
                            <div *ngIf="getFilteredMappedMessages().length === 0"
                                class="text-center text-muted mt-3">
                                <p>{{ communicationSearch ? 'No Messages Found' : 'No mapped Message Logs' }}</p>
                            </div>
                        </div>
                        <div *ngSwitchCase="Subtabs.calls">
                            <div class="d-flex justify-content-between py-2 align-items-center">
                                 <p class="m-0">{{ calculatedate(getFilteredMappedCalls()) }}</p>
                                 <div class="btn-group" dropdown>
                                     <button id="button-calls-filter-mapped" dropdownToggle type="button" 
                                         class="missed-calls-dropdown-btn d-flex align-items-center"
                                         [ngClass]="{ 'missed-calls-active': showMissedCalls }">
                                         <span class="dot me-2" *ngIf="!showMissedCalls && mappedCallAlertCount > 0"></span>
                                         <span [ngClass]="showMissedCalls ? 'text-danger' : 'text-success'">
                                             {{ showMissedCalls ? 'Missed Calls' : 'All Calls' }}
                                         </span>
                                         <i class="fa fa-chevron-down ms-2 fs-10" style="opacity: 0.7;"></i>
                                     </button>
                                     <ul id="dropdown-calls-filter-mapped" *dropdownMenu class="dropdown-menu dropdown-menu-right shadow-sm border-0 radius-12 py-2" role="menu">
                                         <li role="menuitem">
                                             <a class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 cursor" (click)="setMissedCallsFilter(false)">
                                                 <span class="fs-14 fw-600 text-success">All Calls</span>
                                             </a>
                                         </li>
                                         <li role="menuitem">
                                             <a class="dropdown-item d-flex justify-content-between align-items-center py-2 px-3 cursor" (click)="setMissedCallsFilter(true)">
                                                 <span class="fs-14 fw-600 text-danger">Missed Calls</span>
                                                 <span class="badge bg-danger rounded-pill ms-2 d-flex align-items-center justify-content-center" 
                                                       style="min-width: 20px; height: 20px; font-size: 11px;"
                                                       *ngIf="mappedCallAlertCount > 0">
                                                     {{ mappedCallAlertCount }}
                                                 </span>
                                             </a>
                                         </li>
                                     </ul>
                                 </div>
                             </div>
                            <div *ngFor="let group of getFilteredMappedCalls()"
                                class="email-card list-group-item list-group-item-action d-flex flex-column"
                                style="margin-right: 30px;"
                                [ngClass]="{ 'flash-new': group.isNew }">
                                <div class="d-flex justify-content-between align-items-center">
                                    <div class="d-flex gap-2 align-items-center">
                                        <img src="assets/images/icons/Vector_sms.png" style="height: 15px;">
                        
                                        From :
                                        <span style="text-decoration: underline; color:#2968DD;">
                                            {{ group.from_number | maskSensitive }}
                                        </span>
                                    </div>
                                    <div class="d-flex align-items-center gap-3">
                                        <span style="opacity: 60%; font-size: 15px;">
                                            {{ timeAgo(group.created) }}
                                        </span>                        
                                    </div>
                                </div>
                                <div class="mt-1" style="font-size: 13px; opacity: 80%;">
                                    To :
                                    <ng-container *ngFor="let to of group.to_numbers; let k = index">
                                        <span>{{ to | maskSensitive }}</span>
                                        <span *ngIf="k < group.to_numbers.length - 1">, </span>
                                    </ng-container>
                                </div>
                                <div class="mt-1" style="font-size: 12px;">
                                    Status :
                                    <span [ngClass]="{
                                        'text-danger': group.call_status === 'no-answer',
                                        'text-success': group.call_status === 'completed'
                                    }">
                                        {{ group.call_status }}
                                    </span>
                                </div>
                                <div class="mt-2">
                                    <span style="font-size: 12px; margin-right:10px;">Accounts ({{ group.accountIds.length }}):</span>
            
                                    <!-- Show first 3 accounts -->
                                    <ng-container *ngIf="!group.showAllAccounts">
                                        <ng-container *ngFor="let acc of group.accountIds | slice:0:3; let i = index">
                                            <span
                                                style="text-decoration: underline; cursor: pointer; color: #2968DD;
                                                                background-color: #2968dd2f; border-radius: 10px; padding: 1px 6px; font-size: 13px;"
                                                (click)="Redirect(group.split_req_ids[i], 'calllogs')">
                                                {{ acc }}
                                            </span>
                                            <span *ngIf="i < 2 && i < group.accountIds.length - 1">, </span>
                                        </ng-container>
            
                                        <!-- + More button -->
                                        <button *ngIf="group.accountIds.length > 3" class="btn btn-light btn-sm px-2 py-0"
                                            style="font-size: 12px; border-radius: 12px; border-radius: 10px; padding: 1px 6px; font-size: 13px; opacity: 90%; margin-top: 20px;"
                                            (click)="group.showAllAccounts = true;">
                                            +{{ group.accountIds.length - 3 }} more
                                        </button>
                                    </ng-container>
            
                                    <!-- Expanded list -->
                                    <ng-container *ngIf="group.showAllAccounts">
                                        <div class="mt-2">
                                            <ng-container *ngFor="let acc of group.accountIds; let j = index">
                                                <span
                                                    class="account-chip"
                                                    style="text-decoration: underline; cursor: pointer; color: #2968DD;
                                                                    background-color: #2968dd2f; border-radius: 10px; padding: 1px 6px; font-size: 13px; width: fit-content;"
                                                    (click)="Redirect(group.split_req_ids[j], 'calllogs')">
                                                    {{ acc }}
                                                </span>
                                                <span *ngIf="j < group.accountIds.length - 1">, </span>
                                            </ng-container>
            
                                            <!-- Show Less -->
                                            <button class="btn btn-link btn-sm ms-2" (click)="group.showAllAccounts = false"
                                                style="text-decoration: none; border: 1px solid rgba(0, 0, 0, 0.11); color: black; border-radius: 10px; padding: 0px; opacity: 90%;font-size: 13px;">
                                                Show less 
                                            </button>
                                        </div>
                                    </ng-container>
                                </div>
                            </div>
                            <div *ngIf="getFilteredMappedCalls().length === 0" class="text-center text-muted mt-3">
                                <p *ngIf="communicationSearch">No Calls Found</p>
                                <p *ngIf="!communicationSearch">{{ showMissedCalls ? 'No Missed Calls' : 'No Call Logs' }}</p>
                            </div>
                        
                        </div>
                    </div>
                </div>
            </ng-container>

        </div>
    </div>

</div>

<div class="google-auth-overlay" *ngIf="showGoogleAuth" role="dialog" aria-modal="true">
  <div class="google-auth">
    <div class="google-auth__icon">
      <svg viewBox="0 0 24 24" width="28" height="28" aria-hidden="true">
        <path fill="#1a6b8a" d="M12 1 3 5v6c0 5.55 3.84 10.74 9 12 5.16-1.26 9-6.45 9-12V5l-9-4zm-1.2 15.6-4.2-4.2 1.7-1.7 2.5 2.5 5.5-5.5 1.7 1.7-7.2 7.2z"/>
      </svg>
    </div>
    <h2 class="google-auth__title">Connect your Google account</h2>
    <p class="google-auth__text">Sign in with Google to verify your identity and continue using the Recuvery Admin Panel.</p>

    <button type="button" class="google-auth__btn" (click)="continueWithGoogle()" [disabled]="googleAuthLoading">
      <span *ngIf="googleAuthLoading" class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
      <svg *ngIf="!googleAuthLoading" viewBox="0 0 48 48" width="20" height="20" aria-hidden="true">
        <path fill="#FFC107" d="M43.6 20.5H42V20H24v8h11.3C33.7 32.7 29.2 36 24 36c-6.6 0-12-5.4-12-12s5.4-12 12-12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 12.9 4 4 12.9 4 24s8.9 20 20 20 20-8.9 20-20c0-1.3-.1-2.4-.4-3.5z"/>
        <path fill="#FF3D00" d="m6.3 14.7 6.6 4.8C14.7 15.1 19 12 24 12c3.1 0 5.8 1.2 7.9 3.1l5.7-5.7C34 6.1 29.3 4 24 4 16.3 4 9.7 8.3 6.3 14.7z"/>
        <path fill="#4CAF50" d="M24 44c5.2 0 9.9-2 13.4-5.2l-6.2-5.2C29.2 35.1 26.7 36 24 36c-5.2 0-9.6-3.3-11.3-8l-6.5 5C9.5 39.6 16.2 44 24 44z"/>
        <path fill="#1976D2" d="M43.6 20.5H42V20H24v8h11.3c-.8 2.2-2.2 4.2-4.1 5.6l6.2 5.2C37 39.2 44 34 44 24c0-1.3-.1-2.4-.4-3.5z"/>
      </svg>
      <span>{{ googleAuthLoading ? 'Waiting for Google…' : 'Continue with Google' }}</span>
    </button>

    <p class="google-auth__note">A Google sign-in window will open. Please allow pop-ups for this site.</p>
  </div>
</div>
